import apiClient from "services/apiClient";

async function addBehavior(data: any) {
  const url = `/admin/behaviors`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addBehavior;
